// react
import React from 'react';

export default function BlockLoader() {
    return (
        <div className="block-loader" role="status" aria-label="Loading">
            <div className="block-loader__spinner" aria-hidden="true" />
        </div>
    );
}
